import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import PropTypes from 'prop-types';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import Tooltip from '@mui/material/Tooltip';
import InfoIcon from '@mui/icons-material/Info';
import DeleteIcon from '@mui/icons-material/Delete';
import {
    IconButton,
    Dialog,
    DialogTitle,
    DialogContent
} from '@mui/material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import CloseIcon from '@mui/icons-material/Close';
import "./FileBrowserModal.css"
import DownloadingIcon from '@mui/icons-material/Downloading';
import AssignmentLateIcon from '@mui/icons-material/AssignmentLate';
import DownloadIcon from '../../Icons/ic_download.svg';
import Routes from "../../routes"
import { RightArrow } from '../../Icons/Icons';
const FileBrowserModal = ({
    open,
    close,
    bottom,
    documentList,
    scroll,
    refresh
}) => {
    const [documents,setDocuments] = useState([])

    const [currentIndex,setCurrentIndex] = useState(0)
    const [currentDocument, setCurrentDocument] = useState({})

    useEffect(() => {
        if (documentList != null && documentList != undefined) {
            setDocuments(documentList)
            setCurrentDocument(documentList[0])
        }
        setCurrentIndex(0);
    }, [documentList])

    const getLastDoc = () => {
        if(currentIndex <= 0){
            setCurrentIndex(0)
            return
        }else{
            setCurrentDocument(documents[currentIndex - 1])
            setCurrentIndex(currentIndex - 1)
        }
    }

    const getNextDoc = () => {

        if(currentIndex >= documents.length - 1){
            return
        }else{
            setCurrentDocument(documents[currentIndex + 1])
            setCurrentIndex(currentIndex + 1)
        }
    }

    const downloadFile = () => {
        window.open(currentDocument.url, '_blank').focus();
    }

    const offsetDocumentIndex = () => {

        var newDocs = documents.filter((obj) => obj.id != currentDocument.id) 

        setDocuments(newDocs)
        
        if (newDocs.length === 0) {
            close();
            if (refresh) {
                refresh();
            }
        } else {
            setCurrentIndex(0)
            setCurrentDocument(newDocs[0])
        }
    }

    const deleteFile = async () => {
        
        fetch("api/Files/DeleteFile", {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            method: 'POST',
            body: JSON.stringify(currentDocument),
        })
            .then(async (response) => {
                const URL = await Promise.resolve(response.json());
                if (response.status == 200) {
                    toast.success("The attachment has been successfully deleted", { duration: 6000 });
                    offsetDocumentIndex()
                }
            })
            .catch(err => console.log(err));
    };

    return (
        <div>
            <Dialog
                open={open}
                onClose={close}
                scroll={scroll}
                aria-labelledby="trakref popup"
                aria-describedby="trakref popup"
                PaperProps={{ sx: { maxWidth: '600px', background: 'transparent', boxShadow: "none" } }}
                sx={{
                    '&.MuiDialog-root': { bottom: `${bottom}vh`}
                }}
            >
                <div className="FileBrowserModal">



                    <div className="heroImageContainer">
                        <ImageList sx={{ width: 600, height: 400 }} cols={1} rowHeight={400}>
                            
                            <ImageListItem
                                key={currentDocument.url}
                                sx={{ '&.MuiImageListItem-root': { overflow: 'hidden' } }}
                                    >
                                {currentDocument.fileExt != '.jpg' && currentDocument.fileExt != '.jpeg' && currentDocument.fileExt != '.png' &&
                                        (<div className="noPreviewContainer">
                                            <div className="innerContainer">

                                                <AssignmentLateIcon sx={{ fontSize: "80px" }} style={{ color: 'white' }} />
                                                <p className="noPreviewText">It looks like this file doesn't have a preview we can show you.</p>
                                            </div>
                                        </div>)}


                                {(currentDocument.fileExt == '.jpg' || currentDocument.fileExt == '.jpeg' || currentDocument.fileExt == '.png') &&
                                        (<img className
                                    src={`${currentDocument.url}`}
                                            alt={"test"}
                                    loading="lazy"
                                        />)}

                                    <ImageListItemBar
                                    title={currentDocument.fileName}

                                    actionIcon={
                                        <div className="actionIconDiv">
                                            <Tooltip title="Download Attachment">
                                                <IconButton
                                                    sx={{ color: 'F5F5F5' }}
                                                aria-label={`star ${currentDocument.title}`}
                                                onClick={() => downloadFile()}                                            >

                                                    <img src={DownloadIcon} alt={currentDocument.fileName} />

                                                </IconButton>
                                            </Tooltip>
                                            <Tooltip title="Delete Attachment">
                                                <IconButton
                                                sx={{ color: 'F5F5F5' }}
                                                aria-label={`star ${currentDocument.title}`}
                                                onClick={() => deleteFile()}>

                                                    <DeleteIcon/>

                                                </IconButton>
                                            </Tooltip>
                                            </div>
                                        }
                                        sx={{
                                            background:
                                                'white',
                                            "& .MuiImageListItemBar-title": { color: "black" },
                                            opacity: 0.85,
                                        }}
                                    />
                                </ImageListItem>
                            
                        </ImageList>
                    </div>
                    <div className="closeModalBtn clickable" onClick={close}>
                        <CloseIcon style={{ color: 'white' }} />
                    </div>
                    
                    <div className="leftArrow clickable" onClick={() => getLastDoc()}>
                        {currentIndex > 0 && (
                            <ArrowBackIosNewIcon style={{ color: 'white' }} />
                        )}
                    </div>

                    <div className="rightArrowCarousel clickable" onClick={() => getNextDoc()}>
                        {currentIndex < documents.length - 1 && (
                            <ArrowForwardIosIcon style={{ color: 'white' }} />
                        )}
                    </div>
                </div>
            </Dialog>
        </div>
    );
};

FileBrowserModal.propTypes = {
    children: PropTypes.node.isRequired,
    open: PropTypes.bool.isRequired,
    close: PropTypes.func.isRequired,
    header: PropTypes.string,
    bottom: PropTypes.number,
    scroll: PropTypes.string,
};

FileBrowserModal.defaultProps = {
    disableEnforceFocus: false,
    header: "",
    bottom: 0,
    scroll: "body",
};

export default FileBrowserModal;